var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question" }, [
    _c("img", {
      attrs: { src: require("../../../static/images/icon/ques.png"), alt: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c(
        "div",
        { staticClass: "ques" },
        [
          _c("h5", [_vm._v("您的年龄是？")]),
          _vm._v(" "),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.age,
                callback: function($$v) {
                  _vm.age = $$v
                },
                expression: "age"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: "1" } }, [
                _vm._v("50岁以上")
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "2" } }, [
                _vm._v("50岁以下")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ques" },
        [
          _c("h5", [_vm._v("您想重点调理的方向是?")]),
          _vm._v(" "),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.nurse,
                callback: function($$v) {
                  _vm.nurse = $$v
                },
                expression: "nurse"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: "1" } }, [
                _vm._v("慢性病")
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "2" } }, [
                _vm._v("养生")
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "3" } }, [_vm._v("其他")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ques" },
        [
          _c("h5", [_vm._v("您是否有听过其他中医课程？")]),
          _vm._v(" "),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.course,
                callback: function($$v) {
                  _vm.course = $$v
                },
                expression: "course"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: "1" } }, [_vm._v("是")]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: "2" } }, [_vm._v("否")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cbtn", on: { click: _vm.submit } }, [
        _c("div", { staticClass: "text" }, [_vm._v("下一步")])
      ])
    ]),
    _vm._v(" "),
    _vm.loading ? _c("div", { staticClass: "mask" }, [_vm._m(0)]) : _vm._e(),
    _vm._v(" "),
    _vm.showWxRes
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "panel panel2" }, [
            _c("div", { staticClass: "df" }, [
              _c("div", { staticClass: "btn left", on: { click: _vm.rePay } }, [
                _vm._v("未支付")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn right", on: { click: _vm.reWechat } },
                [_vm._v("已支付,添加老师")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-white" }, [
      _c("i", { staticClass: "el-icon-loading" }),
      _vm._v(" "),
      _c("p", [_vm._v("正在加载中...")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42a33390", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42a33390","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/questionNew.vue
// module id = l3ye
// module chunks = 1